import React from 'react'
import { styled } from '@mui/material/styles'
import ReactPaginate from 'react-paginate'
import PropTypes from 'prop-types'

const PREFIX = 'PriceHistorySearchTable'

const classes = {
  root: `${PREFIX}-root`,
  active: `${PREFIX}-active`,
}

const Root = styled('div')(({ theme }) => ({
  [`& .${classes.root}`]: {
    display: 'flex',
    listStyle: 'none',
    marginTop: theme.spacing(2),
    color: 'rgb(9, 42, 72)',
    maxWidth: '350px',
    justifyContent: 'space-between',
    padding: 0,
  },
  [`& .${classes.active}`]: {
    color: theme.palette.primary.dark,
  },
}))

export default function PriceHistorySearchTable({ pageCount, onPageChange }) {
  return (
    <Root>
      <ReactPaginate
        previousLabel="<"
        nextLabel=">"
        breakLabel="..."
        breakClassName="break-me"
        pageCount={pageCount}
        marginPagesDisplayed={2}
        pageRangeDisplayed={5}
        onPageChange={onPageChange}
        containerClassName={classes.root}
        subContainerClassName="pages pagination"
        activeClassName={classes.active}
      />
    </Root>
  )
}

PriceHistorySearchTable.propTypes = {
  pageCount: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
}
